import { render, staticRenderFns } from "./CareerOpportunities.vue?vue&type=template&id=23039fd2&"
import script from "./CareerOpportunities.vue?vue&type=script&lang=js&"
export * from "./CareerOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports